export const createBankSlug = (
  bankName: string,

  country: string,
  currency: string
): string => {
  const slugSuffix = `--${country.toLowerCase()}-${currency.toLowerCase()}`;

  return (
    bankName
      .trim() // remove all prefixed & suffixed whitespaces
      .toLowerCase()
      .replace("-", "")
      .replace("_", "")
      .replace(/[^\w\s]/g, "") // remove all special characters
      .replace(/\s+/g, "-") + // replace all whitespace clusters with a hyphen
    slugSuffix
  );
};
